import { render, staticRenderFns } from "./videosCourse.vue?vue&type=template&id=157d24be&scoped=true"
import script from "./videosCourse.vue?vue&type=script&lang=js"
export * from "./videosCourse.vue?vue&type=script&lang=js"
import style0 from "./videosCourse.vue?vue&type=style&index=0&id=157d24be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157d24be",
  null
  
)

export default component.exports